import Template from './Clock.njk';
import Marionette from "backbone.marionette";
import moment from "moment-timezone";
import { Config } from "../../application/Config";

export const ClockView = Marionette.View.extend({
  template: Template,
    tagName: 'time',

    initialize() {
        this.updateInterval = setInterval(() => {
            this.render();
        }, 1000)
    },

    onBeforeDestroy() {
        clearInterval(this.updateInterval);
        this.updateInterval = null;
    },

    templateContext() {
        return {
            time: moment.tz(Config.timezone).format("LTS")
        }
    }
});



// WEBPACK FOOTER //
// ./src/js/view/components/Clock.js